// routes.js
import {createBrowserRouter,
    createRoutesFromElements,
    Route,
  } from 'react-router-dom';
// import HomeScreen from '../screens/home';
// import ShopScreen from '../screens/shop';
// import CartScreen from '../screens/cart';
// import Checkout from '../screens/checkout';
// import LoginScreen from '../screens/login';
// import RegisterScreen from '../screens/register';
// import ProductScreen from '../screens/product';
import App from '../App';
// import Address from '../screens/address';
// import Payment from '../screens/payment';
// import Orders from '../screens/orders';
// import ShowOrder from '../screens/showOrder';
// import TermsAndConditions from '../screens/policies/termsAndConditions';
// import ShippingAndDelivery from '../screens/policies/shippngAndDelivery';
// import PrivacyPolicy from '../screens/policies/privacyPolicy';
// import CancellationAndRefund from '../screens/policies/cancellationAndRefund';
import HomePageOne from '../../resources/pages/HomePageOne';
import HomePageTwo from '../../resources/pages/HomePageTwo';
import HomePageThree from '../../resources/pages/HomePageThree';
import HomePageVillageZone from '../../resources/pages/HomePageVillageZone';
import ShopPage from '../../resources/pages/ShopPage';
import CartPage from '../../resources/pages/CartPage';
import CheckoutPage from '../../resources/pages/CheckoutPage';
import AccountPage from '../../resources/pages/AccountPage';
import ProductDetailsPageOne from '../../resources/pages/ProductDetailsPageOne';
import TermAndConditionsPage from '../../resources/pages/TermsAndConditionsPage';
import PrivacyPolicyPage from '../../resources/pages/PrivacyPolicyPage';
import CancellationAndRefundPage from '../../resources/pages/CancellationAndRefundPage';
import ShippingAndDeliveyPage from '../../resources/pages/ShippingAndDeliveyPage';
import OrderListPage from '../../resources/pages/OrderListPage';
import OrderDetailsPage from '../../resources/pages/OrderDetailsPage';
import VendorPage from '../../resources/pages/VendorPage';
import ForgotPasswordPage from '../../resources/pages/ForgotPasswordPage';
import DeleteUserPage from '../../resources/pages/DeleteUserPage';
import VendorStoriesPage from '../../resources/pages/VendorStoriesPage';

const router = createBrowserRouter(
    createRoutesFromElements(
        <Route path='/' element={<App />}>
            <Route index={true} path='/' element={<HomePageVillageZone />} />
            <Route path='/shop' element={<ShopPage />} />
            <Route path='/cart' element={<CartPage />} />
            <Route path='/checkout' element={<CheckoutPage />} />
            <Route path='/account' element={<AccountPage />} />
            <Route path='/password' element={<ForgotPasswordPage />} />
            <Route path='/delete' element={<DeleteUserPage />} />
            <Route path='/terms-and-conditions' element={<TermAndConditionsPage />} />
            <Route path='/privacy-policy' element={<PrivacyPolicyPage />} />
            <Route path='/cancellation-and-refund' element={<CancellationAndRefundPage />} />
            <Route path='/shipping-and-delivery' element={<ShippingAndDeliveyPage />} />
            <Route path='/order-list' element={<OrderListPage />} />
            <Route path='/order-details/:orderId' element={<OrderDetailsPage />} />
            <Route path='/product-details/:productSlug' element={<ProductDetailsPageOne />} />
            <Route exact path='/vendor' element={<VendorPage />} />
            {/* <Route index={true} path='/vendor-stories' element={<VendorStoriesPage />} /> */}

            {/* 
            
            <Route index={true} path='/' element={<HomePageOne />
            <Route index={true} path='/' element={<HomePageTwo />
            <Route index={true} path='/' element={<HomePageThree />
            <Route path='/payment' element={<Payment />} />
            <Route path='/orders' element={<Orders />} />
            <Route path='/order/:orderId' element={<ShowOrder />} />
            <Route path='/address' element={<Address />} />
            <Route path='/login' element={<LoginScreen />} />
            <Route path='/register' element={<RegisterScreen />} />
            <Route path='/product/view/:productId' element={<ProductScreen />} />
            <Route path='/terms-and-conditions' element={<TermsAndConditions/>} />
            <Route path='/shipping-and-delivery' element={<ShippingAndDelivery/>} />
            <Route path='/privacy-policy' element={<PrivacyPolicy/>} />
            <Route path='/cancellation-and-refund' element={<CancellationAndRefund />} /> */}

        </Route>
    )
);

export default router;
